const log = {
    invalid_type: '日志类型无效。',
    invalid_time_window: '`end_time` 必须晚于 `start_time`。',
};
export default Object.freeze(log);
